import { render, staticRenderFns } from "./updateFile.vue?vue&type=template&id=06bc92fe&scoped=true"
import script from "./updateFile.vue?vue&type=script&lang=js"
export * from "./updateFile.vue?vue&type=script&lang=js"
import style0 from "./updateFile.vue?vue&type=style&index=0&id=06bc92fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bc92fe",
  null
  
)

export default component.exports